export default __webpack_public_path__ + "static/media/tractive_2.6bd58614.jpg";